export default "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.woff?eff1de88dccf6ab889868a96af6c9a3d";